import { db } from '../firebase';
import { collection, doc, setDoc, getDoc, updateDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { Team } from '../types/user';

// 建立團隊
export const createTeam = async (teamData: Omit<Team, 'createdAt' | 'updatedAt'>): Promise<void> => {
  const teamRef = doc(db, 'teams', teamData.teamId);
  await setDoc(teamRef, {
    ...teamData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
};

// 更新團隊資料
export const updateTeam = async (teamId: string, teamData: Partial<Team>): Promise<void> => {
  const teamRef = doc(db, 'teams', teamId);
  await updateDoc(teamRef, {
    ...teamData,
    updatedAt: serverTimestamp()
  });
};

// 取得團隊資料
export const getTeam = async (teamId: string): Promise<Team | null> => {
  const teamRef = doc(db, 'teams', teamId);
  const teamSnap = await getDoc(teamRef);
  if (teamSnap.exists()) {
    return teamSnap.data() as Team;
  }
  return null;
};

// 取得使用者的團隊列表
export const getUserTeams = async (userId: string): Promise<Team[]> => {
  const teamsRef = collection(db, 'teams');
  const q = query(teamsRef, where('members', 'array-contains', userId));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => doc.data() as Team);
};

// 解析客戶資料字串
export const parseClientsData = (clientsData: string): Team['clients'] => {
  return clientsData
    .split('\n')
    .filter(line => line.trim())
    .map(line => {
      const [name, email, key] = line.split(',').map(item => item.trim());
      return {
        name,
        email,
        key,
        createdAt: new Date()
      };
    });
}; 